import StarWidget from './StarWidget.svelte'
import configModule from '../config'
import { generateDataAttribute } from '../loader/utils'
import { isArrayNotEmpty } from '../utils'

const config = configModule()
const env = process.env.NODE_ENV
const mode = env || 'development'

const dataAttribute = generateDataAttribute(
  config.widgetTypeId,
  config.starWidgetDocumentId
)
const devtool = 'source-map'

const loadStarWidget = ({ settingsResponse, wixProductId, reviewsResponse, collectionPageContents = [] }) => {
  if (wixProductId) {
    const wixDataAttribute = generateDataAttribute(
      config.wixDataKey,
      config.wixStarWidgetPlaceholder
    )

    const target = document.querySelector(`[${wixDataAttribute}]`)
    return new StarWidget({
      target,
      devtool,
      mode,
      props: {
        productId: wixProductId,
        settingsResponse,
        reviewsResponse
      }
    })
  }

  if (isArrayNotEmpty(collectionPageContents)) {
    const wixDataAttributeGalleryContainer = generateDataAttribute(
      config.wixDataKey,
      config.wixStarWidgetOnCollectionsPageGalleryContainer
    )

    const wixDataAttributeSliderContainer = generateDataAttribute(
      config.wixDataKey,
      config.wixStarWidgetOnCollectionsPageSliderContainer
    )
    const wixDataAttributeProductDetailTargets = generateDataAttribute(
      config.wixDataKey,
      config.wixStarWidgetOnCollectionsPageDetailsPlaceholder
    )

    const wixProductNamePlaceholder = generateDataAttribute(
      config.wixDataKey,
      config.wixProductNamePlaceholder
    )

    const sliderContainers = document.querySelectorAll(`[${wixDataAttributeSliderContainer}]`)
    const sliderProductDetailTargets = isArrayNotEmpty(sliderContainers) && [...sliderContainers]
      .map(sliderContainer => Array.from(sliderContainer.querySelectorAll(`[${wixDataAttributeProductDetailTargets}]`)))

    const galleryContainers = document.querySelectorAll(`[${wixDataAttributeGalleryContainer}]`)
    const galleryProductDetailTargets = isArrayNotEmpty(galleryContainers) && [...galleryContainers]
      .map(galleryContainer => Array.from(galleryContainer.querySelectorAll(`[${wixDataAttributeProductDetailTargets}]`)))
    const starWidgetDataHook = generateDataAttribute(config.wixDataKey, config.starWidgetDataHook)

    collectionPageContents.map((content) => {
      const productId = content.id
      let target
      if (content.list === 'Slider Gallery') {
        target = isArrayNotEmpty(sliderProductDetailTargets) && sliderProductDetailTargets.flat()
          .find(element => element.querySelector(`[${wixProductNamePlaceholder}]`).textContent === content.name)
      } else if (content.list === 'Grid Gallery') {
        const possibleTargets = isArrayNotEmpty(galleryProductDetailTargets) && galleryProductDetailTargets.map(arrayOfTargets =>
          arrayOfTargets[content.position]
        )

        target = isArrayNotEmpty(possibleTargets) && possibleTargets.find(element => element && element.querySelector(`[${wixProductNamePlaceholder}]`).textContent === content.name)
      }
      const starWidget = target && target.querySelectorAll(`[${starWidgetDataHook}]`)
      const isStarWidget = starWidget && starWidget.length === 0
      return isStarWidget && productId && new StarWidget({
        target,
        devtool,
        mode,
        props: {
          productId,
          settingsResponse,
          isCollectionPage: collectionPageContents.length > 0
        }
      })
    })
  }

  const newStarRatingTargets = document.querySelectorAll(`[${dataAttribute}]`)

  newStarRatingTargets.forEach(target => {
    const productId = target.getAttribute('id')
    return new StarWidget({
      target,
      devtool,
      mode,
      props: {
        productId,
        settingsResponse
      }
    })
  })

  const oldStarRatingTargets = document.querySelectorAll(`.${config.legacyStarWidgetDocumentId}`)
  oldStarRatingTargets.forEach(target => {
    const productId = target.getAttribute('id')
    return new StarWidget({
      target,
      devtool,
      mode,
      props: {
        productId,
        settingsResponse
      }
    })
  })
}

export default loadStarWidget
